import { AfterViewInit, Component } from '@angular/core';

@Component({
    selector: '[app-objects-dashboard]',
    templateUrl: './objects-dashboard.component.html',
    styleUrls: ['./objects-dashboard.component.css'],
    standalone: false
})

export class ObjectsDashboardComponent implements AfterViewInit
{
  ngAfterViewInit() {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "ObjectsDashboard" }));
  }
}
